import React from 'react'

import MainSectionLayout from '@/main-section-layout'
import ApplySurveyForm from '@/apply-survey-form'
import PageTopBar from '@/page-top-bar'
import Icon from '@/icons'

import './styles.css'

const SectionApplySurvey = () => {
  return (
    <PageTopBar iconName="scale" text="Get started" isGold>
      <MainSectionLayout
        title="What happens when you contact Next Miss"
        about="We care about our clients' time and make sure we offer the most streamlined, transparent and predictable process possible."
      >
        <div className="gray tc mb4">
          <Icon icon="arrow-down" height="20px" className="mr2 relative top07" />
          <span className="f11 ">Start by Filling the Next Miss form below</span>
        </div>

        <ApplySurveyForm />
      </MainSectionLayout>
    </PageTopBar>
  )
}

export default SectionApplySurvey



// WEBPACK FOOTER //
// ./src/components/section-apply-survey/section-apply-survey.js